import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination } from "../common";

const AddViewUploads = () => {
  return (
    <div>
      <PageTitle title='Add/View Uploads' role='Reviewer' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='After logging in as a role with Reviewer privileges, any events waiting on the Reviewer to review will allow the Reviewer to also submit and view uploaded documents. These events assigned to the Reviewer will be listed under the "My Reviews" tab. If no tab is present, then no reviews are currently assigned. Once clicking on the "My Reviews" tab, a table listing all the assigned events will be populated. Click on the event to review to view the Event Summary page. Note: Risk Managers and above can upload documents at any time.' />
      <ParaImageDialog src='/tutorial_image/add-view-uploads-1.png' />
  
      <ParaTitle paraTitle='Upload Files Tab' />
      <Paragraph paragraph='The uploaded files are listed under the "Upload Files" tab on the Event Summary page. A total number of 5 files may be uploaded to any given event. If the event is not closed, then any user with whom the event is assigned has the ability to add, delete, and view the uploaded documents. As soon as the event reaches a "Closed" status, the documents are unable to be modified and can only be viewed.' />
      <ParaImageDialog src='/tutorial_image/add-view-uploads-2.png' />

      <ParaTitle paraTitle='Uploading Documents' />
      <Paragraph paragraph='To upload a new document, click the folder icon. The browser&#39;s default file selector will appear. The file to upload must be a .pdf document and the filename must be less than 100 characters. If the filename is greater than 100 characters, the application will display an error message telling the user to rename the file and attempt to upload again.' />
      <ParaImageDialog src='/tutorial_image/add-view-uploads-3.png' />

      <ParaTitle paraTitle='View or Delete Documents' />
      <Paragraph paragraph='To view a document, click the document&#39;s name from the list. The application will download the document to the user&#39;s Downloads directory to open with the default .pdf viewer. To delete the document, select the "Delete" button. The browser will display a confirmation message and after confirming, the document will be deleted.' />
      <ParaImageDialog src='/tutorial_image/add-view-uploads-4.png' />

      <Pagination
        pagination={{
          prev: { name: 'Linked Events', link: '/risk-manager/linked-events' },
          next: { name: 'User Management', link: '/risk-manager/user-management' }
        }}
      />
    </div>
  );
};

export default AddViewUploads;
